<!-- 记录明细 -->
<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      :showSummary="showSummary"
      summaryProperty="showNum"
      :pageSize="20"
      height="calc(100vh - 210px)"
      :showPagination="true"
      @onSelectChange="onSelectChange"
      rowKey="productRecordsId"
      :searchAttrName="searchAttrName"
      tableName="warehouseDateRecord"
      exportDataUrl="/outInputRecords/selectOutInRecordsDetail"
      @onSearch="handleSearch"
    >
    </Table>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { ref, onMounted, watch } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  selectOutInRecordsDetail
} from "@/api/warehouse/warehouseDate";
import useCacheStore from "@/store/modules/cache";
import { isNull } from "@/utils/fangerUtils";
import { succesMsg } from "@/utils/msgBox";
import { useRoute } from "vue-router";
const cacheStore = useCacheStore();

const { getProductById } = cacheStore;

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "warehouseDateRecord",
});
const proId = ref();
const route = useRoute();

watch(
  () => route.query,
  (newVal, oldVal) => {
    proId.value = newVal.proId || "";
    // proSearch()
  },
  {
    immediate: true,
  }
);
const tableData = ref([]);
const tableRef = ref(null);

const total = ref(0);
const loading = ref(false);
const showSummary = ref(false);

const searchAttrName = ["productName", "eqptCode"];

const selectVals = ref([]);
const onSelectChange = (vals) => {
  selectVals.value = [];
  selectVals.value = vals;
  if (selectVals.value.length > 0) {
    showSummary.value = true;
  } else {
    showSummary.value = false;
  }
};
// const getSummaries = (param)=>{
//   const { columns, data } = param;
//   const sums = [];
//   columns.forEach((column, index) => {
//       if (index === 0) {
//         sums[index] = '产品数量';
//         return;
//       }
//       const values = selectVals.value.map(item => Number(item[column.property]));
//       if (column.property === 'productNum') {
//             if (!values.every(value => isNaN(value))) {
//                 sums[index] = values.reduce((prev, curr) => {
//                 const value = Number(curr);
//                 if (!isNaN(value)) {
//                     return prev + curr;
//                 }else {
//                     return prev;
//                 }
//               }, 0);
//                 sums[index] ;
//               } else {
//                 sums[index] = '---'
//             }
//          }
//   })
//   return sums
// }

// 搜索
const handleSearch = (data) => {
  loading.value = true;
  selectOutInRecordsDetail({
      ...data,
    })
      .then((res) => {
        tableData.value = res.data;
        total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
      })
      .catch((res) => {})
      .finally(() => {
        loading.value = false;
      });
  // if (proId.value) {
  //   selectProductInventoryByProductRecordsId({ productRecordsId: proId.value })
  //     .then((res) => {
  //       tableData.value = res.data;
  //     })
  //     .finally(() => {
  //       loading.value = false;
  //     });
  // } else {
  //   selectOutInRecordsDetail({
  //     ...data,
  //   })
  //     .then((res) => {
  //       tableData.value = res.data;
  //       total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
  //     })
  //     .catch((res) => {})
  //     .finally(() => {
  //       loading.value = false;
  //     });
  // }
};

const columns = getCustomTableCols([
  "outInWarehouseName",
  "outInWarehouseStatus",
  "outInType",
  "projectName",
  "outWarehouse",
  "inWarehouse",
  "productName",
  "productType",
  "usageType",
  "eqptCode",
  "showNum",
  "recipient",
  "trackingNumber",
  "returnAddress",
  "batchNo",
  "contractNo",
  "projectNo",
  "classification",
  "remarks",
  "supplier",
  "checkInventoryDisposalMode",
  "supplierModel",
  "internalModel",
  "returnInWarehouse",
  "operateTime",
  "operatorName",
]);
</script>

<style lang="scss" scoped></style>
